import { validatePlatformContent } from "utils/newMediaValidation";

/**
 * Validates LinkedIn post content and media
 * @param {Object} params - The parameters for validation
 * @param {String} params.caption - The post caption
 * @param {Array} params.mediaList - Media files for the post
 * @param {Number} params.monthlyPosts - Available monthly posts
 * @returns {Boolean} - Whether the post has validation errors
 */
const validateLinkedin = ({ caption, mediaList, monthlyPosts }) => {
  const errorList = [];
  
  const { platformErrors, mediaList: mediaListValidated } =
    validatePlatformContent({
      mediaListRaw: mediaList,
      platform: "linkedin",
      caption,
    });

  errorList.push(
    platformErrors.length > 0 ||
      mediaListValidated.some((media) => media.errors.length > 0)
  );
  errorList.push(monthlyPosts < 1);

  return errorList.includes(true);
};

export default validateLinkedin;
